export enum Category{
  Kebab = 'kebab',
  Button = 'button',
  Header = 'header',
  SubHeader = 'subHeader',
  Custom = 'Custom',
};
